<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width,initial-scale=1.0" />

    <link rel="apple-touch-icon" sizes="76x76" href="apple-touch-icon.png" />
    <link rel="icon" type="image/png" sizes="32x32" href="favicon-32x32.png" />
    <link rel="icon" type="image/png" sizes="16x16" href="favicon-16x16.png" />
    <link rel="manifest" href="site.webmanifest" />
    <meta name="msapplication-TileColor" content="#da532c" />
    <meta name="theme-color" content="#ffffff" />

    <title>AURA Dashboard</title>
  </head>
  <body>
    <noscript>
      <strong
        >We're sorry but dboard doesn't work properly without JavaScript enabled. Please enable it
        to continue.</strong
      >
    </noscript>
    <div id="app"></div>
    <script type="module" src="./src/main.ts"></script>
  </body>
</html>
